import type { IconSvgObject } from './types';

const Motion02Icon: IconSvgObject = [
  ["path", { d: "M21 12C21.5523 12 22 12.4477 22 13V21C22 21.5523 21.5523 22 21 22H13C12.4477 22 12 21.5523 12 21V13C12 12.4477 12.4477 12 13 12H21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 3.5V3C10 2.44772 9.55228 2 9 2H3C2.44772 2 2 2.44772 2 3V9C2 9.55228 2.44772 10 3 10H3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 9V8C17 7.44772 16.5523 7 16 7H8C7.44772 7 7 7.44772 7 8V16C7 16.5523 7.44772 17 8 17H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Motion02Icon;
